import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import settingsPageReducer from './data/reducer';
import settingsPageSaga, { initSaga } from './data/sagas';
import supplierFacilityDrawerReducer from './supplierFacilityDrawer/data/reducer';
import supplierFacilityDrawerSaga from './supplierFacilityDrawer/data/sagas';

const reducer = combineReducers({
  drawer: supplierFacilityDrawerReducer,
  settingsPage: settingsPageReducer,
});

const saga = function* () {
  yield all([settingsPageSaga(), supplierFacilityDrawerSaga()]);
};

export { initSaga, reducer, saga };
